// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!./styles/emr-typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Arial, "Helvetica Neue", Helvetica, "Liberation Sans", "Segoe UI", sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
:root {
        --background: 0 0% 100%;
        --foreground: 0 0% 3.9%;
        --card: 0 0% 100%;
        --card-foreground: 0 0% 3.9%;
        --popover: 0 0% 100%;
        --popover-foreground: 0 0% 3.9%;
        --primary: 0 0% 9%;
        --primary-foreground: 0 0% 98%;
        --secondary: 0 0% 96.1%;
        --secondary-foreground: 0 0% 9%;
        --muted: 0 0% 96.1%;
        --muted-foreground: 0 0% 45.1%;
        --accent: 0 0% 96.1%;
        --accent-foreground: 0 0% 9%;
        --destructive: 0 84.2% 60.2%;
        --destructive-foreground: 0 0% 98%;
        --border: 0 0% 89.8%;
        --input: 0 0% 89.8%;
        --ring: 0 0% 3.9%;
        --chart-1: 12 76% 61%;
        --chart-2: 173 58% 39%;
        --chart-3: 197 37% 24%;
        --chart-4: 43 74% 66%;
        --chart-5: 27 87% 67%;
        --radius: 0.5rem;
    }
.dark {
        --background: 0 0% 3.9%;
        --foreground: 0 0% 98%;
        --card: 0 0% 3.9%;
        --card-foreground: 0 0% 98%;
        --popover: 0 0% 3.9%;
        --popover-foreground: 0 0% 98%;
        --primary: 0 0% 98%;
        --primary-foreground: 0 0% 9%;
        --secondary: 0 0% 14.9%;
        --secondary-foreground: 0 0% 98%;
        --muted: 0 0% 14.9%;
        --muted-foreground: 0 0% 63.9%;
        --accent: 0 0% 14.9%;
        --accent-foreground: 0 0% 98%;
        --destructive: 0 62.8% 30.6%;
        --destructive-foreground: 0 0% 98%;
        --border: 0 0% 14.9%;
        --input: 0 0% 14.9%;
        --ring: 0 0% 83.1%;
        --chart-1: 220 70% 50%;
        --chart-2: 160 60% 45%;
        --chart-3: 30 80% 55%;
        --chart-4: 280 65% 60%;
        --chart-5: 340 75% 55%;
    }
*{
  border-color: hsl(var(--border));
}
body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}
[data-debug-wrapper="true"] {
        display: contents !important;
    }
[data-debug-wrapper="true"] > * {
        margin-left: inherit;
        margin-right: inherit;
        margin-top: inherit;
        margin-bottom: inherit;
        padding-left: inherit;
        padding-right: inherit;
        padding-top: inherit;
        padding-bottom: inherit;
        column-gap: inherit;
        row-gap: inherit;
        gap: inherit;
        border-left-width: inherit;
        border-right-width: inherit;
        border-top-width: inherit;
        border-bottom-width: inherit;
        border-left-style: inherit;
        border-right-style: inherit;
        border-top-style: inherit;
        border-bottom-style: inherit;
        border-left-color: inherit;
        border-right-color: inherit;
        border-top-color: inherit;
        border-bottom-color: inherit;
    }
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-12{
  left: -3rem;
}
.-right-12{
  right: -3rem;
}
.-top-12{
  top: -3rem;
}
.bottom-0{
  bottom: 0px;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-4{
  top: 1rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[200\\]{
  z-index: 200;
}
.z-\\[60\\]{
  z-index: 60;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-auto{
  margin-top: auto;
}
.\\!block{
  display: block !important;
}
.block{
  display: block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.\\!table{
  display: table !important;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[520px\\]{
  max-height: 520px;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-\\[calc\\(90vh-10rem\\)\\]{
  max-height: calc(90vh - 10rem);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[24rem\\]{
  min-height: 24rem;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[96px\\]{
  min-height: 96px;
}
.min-h-\\[var\\(--radix-select-trigger-height\\)\\]{
  min-height: var(--radix-select-trigger-height);
}
.min-h-min{
  min-height: min-content;
}
.min-h-screen{
  min-height: 100vh;
}
.w-10{
  width: 2.5rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-44{
  width: 11rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[10\\.75rem\\]{
  width: 10.75rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[10rem\\]{
  width: 10rem;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[248px\\]{
  width: 248px;
}
.w-\\[4\\.5rem\\]{
  width: 4.5rem;
}
.w-\\[5\\.75rem\\]{
  width: 5.75rem;
}
.w-\\[6\\.5rem\\]{
  width: 6.5rem;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[1080px\\]{
  min-width: 1080px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[640px\\]{
  min-width: 640px;
}
.min-w-\\[720px\\]{
  min-width: 720px;
}
.min-w-\\[880px\\]{
  min-width: 880px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[920px\\]{
  min-width: 920px;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-\\[10rem\\]{
  max-width: 10rem;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.table-fixed{
  table-layout: fixed;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#1E79E8\\]\\/20{
  border-color: rgb(30 121 232 / 0.2);
}
.border-\\[\\#1E79E8\\]\\/40{
  border-color: rgb(30 121 232 / 0.4);
}
.border-\\[\\#6B4C9A\\]{
  --tw-border-opacity: 1;
  border-color: rgb(107 76 154 / var(--tw-border-opacity, 1));
}
.border-\\[\\#6B4C9A\\]\\/40{
  border-color: rgb(107 76 154 / 0.4);
}
.border-\\[\\#d4c8e8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(212 200 232 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e4d8c8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 216 200 / var(--tw-border-opacity, 1));
}
.border-\\[\\#f0e6d8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(240 230 216 / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-sky-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-transparent{
  border-color: transparent;
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#0b1f33\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 31 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0d5c4d\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(13 92 77 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1976D2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(25 118 210 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E79E8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 121 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1d4ed8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e3a8a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6B4C9A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(107 76 154 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5F0FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 240 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EDE6F7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(237 230 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F2FB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 242 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F6FC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 246 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FBF8FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 248 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/70{
  background-color: rgb(239 246 255 / 0.7);
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-950{
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-500\\/15{
  background-color: rgb(20 184 166 / 0.15);
}
.bg-teal-500\\/20{
  background-color: rgb(20 184 166 / 0.2);
}
.bg-teal-600{
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.bg-teal-700{
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.fill-amber-400{
  fill: #fbbf24;
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-base{
  font-size: 16px;
  line-height: 1.45;
}
.text-button{
  font-size: 14px;
  line-height: 1.2;
}
.text-card-title{
  font-size: 15px;
  line-height: 1.3;
}
.text-helper{
  font-size: 13px;
  line-height: 1.45;
}
.text-label{
  font-size: 13px;
  line-height: 1.35;
}
.text-lg{
  font-size: 18px;
  line-height: 1.3;
}
.text-metadata{
  font-size: 12px;
  line-height: 1.35;
}
.text-micro{
  font-size: 11px;
  line-height: 1.35;
}
.text-page-title{
  font-size: 21px;
  line-height: 1.2;
}
.text-sm{
  font-size: 14px;
  line-height: 1.45;
}
.text-table{
  font-size: 14px;
  line-height: 1.35;
}
.text-table-head{
  font-size: 13px;
  line-height: 1.3;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 13px;
  line-height: 1.35;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#1E79E8\\]{
  --tw-text-opacity: 1;
  color: rgb(30 121 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d4ed8\\]{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1e3a8a\\]{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B4C9A\\]{
  --tw-text-opacity: 1;
  color: rgb(107 76 154 / var(--tw-text-opacity, 1));
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950{
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-teal-100{
  --tw-text-opacity: 1;
  color: rgb(204 251 241 / var(--tw-text-opacity, 1));
}
.text-teal-300{
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-teal-800{
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.accent-\\[\\#0d5c4d\\]{
  accent-color: #0d5c4d;
}
.accent-\\[\\#6B4C9A\\]{
  accent-color: #6B4C9A;
}
.opacity-0{
  opacity: 0;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 1px 2px rgba(15,23,42,0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(50\\2c 32\\2c 12\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 1px 2px rgba(50,32,12,0.06);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#0b1f33\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(11 31 51 / var(--tw-ring-opacity, 1));
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-slate-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 245 249 / var(--tw-ring-opacity, 1));
}
.ring-teal-400\\/30{
  --tw-ring-color: rgb(45 212 191 / 0.3);
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{
  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{
  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}

body {
    margin: 0;
    font-family: var(--emr-font-sans);
    font-size: var(--emr-type-body);
    line-height: var(--emr-leading-body);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

code, pre, .font-fhir {
    font-family: var(--emr-font-mono);
}

/* Print Note: hide Encounter chrome; show only the selected-note document. */
.note-print-root {
    display: none;
}

@media print {
    @page {
        size: letter;
        margin: 0.6in;
    }

    html,
    body {
        height: auto !important;
        min-height: 0 !important;
        overflow: visible !important;
        background: #fff !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    /*
     * beforeprint hoists .note-print-root onto document.body. Hide every other
     * body child so Encounter chrome (visibility:hidden still occupies space)
     * cannot generate a blank first sheet.
     */
    body > *:not(.note-print-root) {
        display: none !important;
    }

    .note-print-root {
        display: block !important;
        position: static !important;
        width: 100% !important;
        color: #0f172a;
        background: #fff !important;
        font-family: var(--emr-font-sans);
    }

    .note-print-header {
        border-bottom: 2px solid #0f172a;
        padding-bottom: 12px;
        margin-bottom: 18px;
    }

    .note-print-kicker {
        margin: 0 0 4px;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.16em;
        text-transform: uppercase;
        color: #475569;
    }

    .note-print-header h1 {
        margin: 0;
        font-size: 22px;
        font-weight: 700;
        line-height: 1.2;
    }

    .note-print-title {
        margin: 6px 0 0;
        font-size: 13px;
        color: #334155;
    }

    .note-print-section {
        margin-bottom: 16px;
        page-break-inside: avoid;
        break-inside: avoid;
    }

    .note-print-section h2 {
        margin: 0 0 8px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: #64748b;
    }

    .note-print-section dl {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 6px 24px;
        margin: 0;
    }

    .note-print-fact dt {
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #64748b;
    }

    .note-print-fact dd {
        margin: 1px 0 0;
        font-size: 13px;
        font-weight: 500;
    }

    .note-print-body {
        margin: 0;
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: var(--emr-font-sans);
        font-size: 13px;
        line-height: 1.55;
        border: 1px solid #cbd5e1;
        padding: 14px;
        min-height: 8rem;
    }

    .note-print-body--rtf {
        white-space: normal;
    }

    .note-print-body--rtf p,
    .note-print-body--rtf div {
        margin: 0 0 0.35em;
    }

    .note-print-body--rtf ul,
    .note-print-body--rtf ol {
        margin: 0 0 0.35em 1.2em;
        padding: 0;
    }

    .note-print-root--templated .note-print-page {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        width: 100%;
        /*
         * Fill the letter content box (11in minus 0.6in @page margins) so flex
         * can park .note-print-template-footer at the bottom of unused space.
         * Keep height:auto + page-break-inside:auto — a fixed 9.8in box with
         * page-break-inside:avoid is deferred to sheet 2 and clips long notes.
         */
        min-height: calc(11in - 1.2in);
        height: auto;
        max-height: none;
        overflow: visible;
        break-after: page;
        page-break-after: always;
        break-inside: auto;
        page-break-inside: auto;
    }

    .note-print-root--templated .note-print-page:last-child {
        break-after: auto;
        page-break-after: auto;
    }

    .note-print-template-header,
    .note-print-template-footer {
        flex: 0 0 auto;
        color: #0f172a;
        font-size: 12px;
        line-height: 1.4;
    }

    .note-print-template-header {
        border-bottom: 1px solid #94a3b8;
        padding-bottom: 10px;
        margin-bottom: 12px;
    }

    .note-print-template-header--subsequent {
        font-size: 11px;
        padding-bottom: 6px;
        margin-bottom: 10px;
    }

    .note-print-page__body {
        flex: 1 1 auto;
        min-height: 0;
        overflow: visible;
    }

    .note-print-template-footer {
        border-top: 1px solid #94a3b8;
        padding-top: 8px;
        margin-top: auto;
        font-size: 11px;
        color: #334155;
    }

    .note-print-root img.grd-logo {
        max-height: 48px;
        max-width: 160px;
        display: inline-block;
    }

    .note-print-root--templated .note-print-body {
        border: 0;
        padding: 0;
        min-height: 0;
    }

    [data-sonner-toaster] {
        display: none !important;
    }
}

.sidebar-nav-sheet > button {
    color: rgb(148 163 184);
}

/* Traditional paper medical-chart folder: rounded tabs, flared joins, layered shadows. */
.chart-folder {
    --chart-rail: #fffdf8;
    --chart-ink: #2c2118;
    --chart-folder-edge: rgba(60, 40, 20, 0.22);
}

.chart-folder-nav {
    position: relative;
    z-index: 4;
    background: var(--chart-rail);
    padding: 8px 10px 0;
    box-shadow: none;
}

.chart-dividers {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: end;
    gap: 10px;
    padding: 0 6px;
}

.chart-divider,
.chart-subtab {
    --tab-bg: #d4c4a0;
    position: relative;
    border: 0;
    background: var(--tab-bg);
    color: var(--chart-ink, #2c2118);
    cursor: pointer;
    filter: drop-shadow(0 3px 3px rgba(50, 32, 12, 0.22));
}

.chart-divider::before,
.chart-divider::after,
.chart-subtab::before,
.chart-subtab::after {
    content: "";
    position: absolute;
    bottom: 0;
    width: 12px;
    height: 12px;
    pointer-events: none;
    background: transparent;
}

.chart-divider::before,
.chart-subtab::before {
    left: -11px;
    border-bottom-right-radius: 12px;
    box-shadow: 6px 0 0 var(--tab-bg);
}

.chart-divider::after,
.chart-subtab::after {
    right: -11px;
    border-bottom-left-radius: 12px;
    box-shadow: -6px 0 0 var(--tab-bg);
}

.chart-divider::before,
.chart-divider::after {
    display: none;
}

.chart-divider {
    z-index: 1;
    display: flex;
    min-height: 64px;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin: 0 8px;
    padding: 12px 16px 14px;
    border-radius: 18px 14px 0 0 / 16px 13px 0 0;
    text-align: left;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.48);
    filter: drop-shadow(0 2px 2px rgba(50, 32, 12, 0.16));
    transform: none;
    clip-path: none;
}

.chart-divider.is-active {
    z-index: 5;
    min-height: 64px;
    padding-bottom: 14px;
    border-radius: 18px 14px 0 0 / 16px 13px 0 0;
    transform: none;
    filter: none;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.chart-divider:hover:not(.is-active) {
    filter: brightness(1.05);
}

.chart-divider:focus-visible {
    outline: 2px solid rgba(44, 33, 24, 0.28);
    outline-offset: 2px;
}

.chart-divider-icon {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
}

.chart-divider-copy {
    min-width: 0;
}

.chart-divider-label {
    display: block;
    font-size: var(--emr-type-body);
    font-weight: var(--emr-weight-title);
    letter-spacing: 0.08em;
    line-height: var(--emr-leading-page-title);
    text-transform: uppercase;
}

.chart-divider-sub {
    display: none;
    margin-top: 3px;
    font-size: var(--emr-type-metadata);
    font-weight: var(--emr-weight-body);
    letter-spacing: 0;
    line-height: 1.3;
    text-transform: none;
    color: #5c4a3a;
}

.chart-divider-sub.is-active {
    color: #4a3a2c;
}

.chart-subtabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
    align-items: flex-end;
    padding: 10px 16px 14px;
    margin-bottom: -14px;
    background: transparent;
    position: relative;
    z-index: 3;
}

.chart-subtab {
    z-index: 2;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 34px;
    margin: 0 6px;
    padding: 7px 13px 16px;
    border-radius: 10px 10px 0 0;
    font-size: var(--emr-type-label);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-page-title);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.chart-subtab-icon {
    width: 13px;
    height: 13px;
    flex-shrink: 0;
}

.chart-subtab.is-active {
    z-index: 6;
    color: #2c2118;
    padding-bottom: 18px;
    box-shadow: inset 0 3px 0 var(--tab-color, #8fa87a);
    filter: drop-shadow(0 4px 5px rgba(50, 32, 12, 0.18));
}

.chart-folder-body {
    position: relative;
    z-index: 1;
    background: #fffdf8;
    border: 1px solid rgba(60, 40, 20, 0.14);
    border-top: 0;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 4px 12px rgba(50, 32, 12, 0.12);
}

.chart-folder-body::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 14px;
    background: var(--chart-rail);
    pointer-events: none;
}

.chart-subtab.is-dark:not(.is-active) {
    color: #fffdf8;
}

/* Clinical hanging-file paper tabs only — does not affect main folder tabs. */
.chart-subtabs--clinical {
    position: relative;
    gap: 0;
    align-items: flex-end;
    padding: 8px 0 0;
    margin-bottom: 0;
    z-index: 5;
}

.chart-subtabs--clinical .chart-subtab {
    z-index: 2;
    margin: 0 0 0 -16px;
    padding: 9px 18px 22px;
    min-height: 36px;
    border-radius: 14px 11px 0 0 / 12px 13px 0 0;
    transform: none;
    clip-path: none;
    filter: none;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.28);
}

.chart-subtabs--clinical .chart-subtab:first-child {
    margin-left: 0;
}

/* Outer row edges blend into the sage folder margin. Inner tab shape/overlap unchanged. */
.chart-subtabs--clinical::before,
.chart-subtabs--clinical::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: -6px;
    width: 20px;
    pointer-events: none;
    z-index: 16;
}

.chart-subtabs--clinical::before {
    left: 0;
    background: linear-gradient(to right, var(--chart-rail) 40%, transparent);
}

.chart-subtabs--clinical::after {
    right: 0;
    background: linear-gradient(to left, var(--chart-rail) 40%, transparent);
}

.chart-subtabs--clinical .chart-subtab:first-child::before {
    display: none;
}

.chart-subtabs--clinical .chart-subtab:last-child::after {
    display: none;
}

.chart-subtabs--clinical .chart-subtab::before,
.chart-subtabs--clinical .chart-subtab::after {
    display: block;
    width: 10px;
    height: 10px;
    background: transparent;
}

.chart-subtabs--clinical .chart-subtab::before {
    left: -9px;
    border-bottom-right-radius: 11px;
    box-shadow: 5px 0 0 var(--tab-bg);
}

.chart-subtabs--clinical .chart-subtab::after {
    right: -8px;
    width: 11px;
    height: 9px;
    border-bottom-left-radius: 10px;
    box-shadow: -5px 0 0 var(--tab-bg);
}

.chart-subtabs--clinical .chart-subtab.is-active {
    z-index: 12;
    transform: none;
    padding-bottom: 22px;
    border-radius: 12px 14px 0 0 / 13px 12px 0 0;
    filter: none;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

/* Domain (main) tabs reuse clinical subtab behavior; only size/shape differ. */
.chart-subtabs--domain.chart-subtabs--clinical .chart-subtab {
    min-height: 48px;
    padding: 10px 20px 22px;
    gap: 12px;
    border-radius: 18px 14px 0 0 / 16px 13px 0 0;
}

.chart-subtabs--domain .chart-subtab-icon {
    width: 22px;
    height: 22px;
}

.chart-subtabs--domain .chart-divider-label {
    text-transform: uppercase;
}

/* Domain main tabs only: share the available chart width equally.
   Does not affect clinical, front-desk, or billing sub-tabs. */
.chart-subtabs--domain.chart-subtabs--clinical {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    justify-content: stretch;
    width: 100%;
    gap: 0;
    padding-left: 12px;
    padding-right: 12px;
}

.chart-subtabs--domain.chart-subtabs--clinical .chart-subtab {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    min-width: 0;
    justify-content: center;
}

.chart-subtabs--domain.chart-subtabs--clinical::before,
.chart-subtabs--domain.chart-subtabs--clinical::after {
    display: none;
}


.chart-folder:has(.chart-subtabs--clinical) .chart-folder-body::before {
    height: 0;
}

.chart-folder:has(.chart-subtabs--clinical) .chart-folder-sheet {
    padding-top: 20px;
}

.chart-folder-sheet {
    padding-top: 1.55rem;
}

.chart-panel {
    border-radius: 6px;
    border: 1px solid #e4d8c8;
    background: #ffffff;
    box-shadow: 0 1px 1px rgba(50, 32, 12, 0.05);
}

.chart-patient-header {
    background: #fbf6ee;
    border-bottom: 1px solid #e4d8c8;
}

.chart-ai-panel {
    background: #f7f4fb;
    border-left: 1px solid #d4c8e8;
}

.chart-ai-head {
    background: #c4b4d8;
    color: #2c2140;
    border-bottom: 1px solid #b8a4d0;
}

.chart-ai-head h2 {
    color: #3d2a66;
}

@media (min-width: 640px) {
    .chart-divider-sub {
        display: block;
    }
}

@media (max-width: 720px) {
    .chart-dividers {
        gap: 4px;
        padding-left: 12px;
        padding-right: 12px;
    }

    .chart-subtabs--domain.chart-subtabs--clinical {
        gap: 0;
        padding-left: 8px;
        padding-right: 8px;
    }

    .chart-divider {
        min-height: 58px;
        padding: 10px 8px 12px;
        gap: 8px;
    }

    .chart-divider-label {
        font-size: var(--emr-type-metadata);
        letter-spacing: 0.05em;
    }
}

.ac-page {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
}

.ac-hero {
    background: #1e3a5f;
    color: #fff;
    border-radius: 0.75rem;
    padding: 1.1rem 1.35rem;
}

.ac-hero h1 {
    margin: 0;
    font-size: var(--emr-type-page-title);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-page-title);
    letter-spacing: -0.02em;
}

.ac-hero p {
    margin: 0.3rem 0 0;
    font-size: var(--emr-type-body);
    color: #d6e4f5;
}

.ac-tabs {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
}

.ac-tab {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    border: 1px solid #dbe3ee;
    background: #fff;
    border-radius: 0.75rem;
    padding: 0.85rem 1rem;
    text-align: left;
    color: #334155;
}

.ac-tab.is-active {
    border-color: #2563eb;
    box-shadow: 0 0 0 1px #2563eb;
    color: #1e3a5f;
}

.ac-tab.is-disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.ac-tab-label {
    display: block;
    font-size: var(--emr-type-card-title);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-card-title);
}

.ac-tab-sub {
    display: block;
    font-size: var(--emr-type-metadata);
    color: #64748b;
}

.ac-panel {
    border: 1px solid #e2e8f0;
    background: #fff;
    border-radius: 0.75rem;
    padding: 1.25rem;
}

.ac-panel-title {
    margin: 0 0 1rem;
    font-size: var(--emr-type-section-title);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-heading);
    color: #0f172a;
}

.ac-section-title {
    margin: 1.25rem 0 0.75rem;
    font-size: var(--emr-type-card-title);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-card-title);
    color: #1e3a5f;
}

.ac-section-title:first-of-type {
    margin-top: 0.25rem;
}

.ac-toolbar {
    display: grid;
    grid-template-columns: minmax(12rem, 16rem) 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
    align-items: start;
}

.ac-toolbar--user {
    grid-template-columns: minmax(16rem, 20rem) 1fr;
}

.ac-field {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    font-size: var(--emr-type-label);
    font-weight: var(--emr-weight-label);
    color: #334155;
}

.ac-field select {
    height: 2.4rem;
    border: 1px solid #cbd5e1;
    border-radius: 0.5rem;
    background: #fff;
    padding: 0 0.7rem;
    font-size: var(--emr-type-body);
    color: #0f172a;
}

.ac-info {
    display: flex;
    gap: 0.6rem;
    align-items: flex-start;
    background: #e8f1fb;
    border: 1px solid #c5daf3;
    color: #1e3a5f;
    border-radius: 0.6rem;
    padding: 0.7rem 0.85rem;
    font-size: var(--emr-type-body);
}

.ac-info-icon {
    width: 1rem;
    height: 1rem;
    margin-top: 0.1rem;
    flex-shrink: 0;
}

.ac-info p {
    margin: 0;
}

.ac-employee {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.65rem;
    padding: 0.75rem 0.9rem;
    background: #f8fafc;
}

.ac-employee span {
    display: block;
    font-size: var(--emr-type-metadata);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b;
    font-weight: var(--emr-weight-title);
}

.ac-employee strong {
    display: block;
    margin-top: 0.15rem;
    font-size: var(--emr-type-body);
    color: #0f172a;
    font-weight: var(--emr-weight-title);
}

.ac-status-active {
    color: #047857 !important;
}

.ac-status-inactive {
    color: #64748b !important;
}

.ac-matrix-stack {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.ac-matrix {
    border: 1px solid #e2e8f0;
    border-radius: 0.65rem;
    overflow: hidden;
}

.ac-matrix-head {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.65rem 0.9rem;
    font-weight: 600;
}

.ac-matrix-head h3 {
    margin: 0;
    font-size: var(--emr-type-card-title);
    line-height: var(--emr-leading-card-title);
}

.ac-matrix-head--front-desk {
    background: #dbeafe;
    color: #1e3a8a;
}

.ac-matrix-head--clinical {
    background: #dcfce7;
    color: #166534;
}

.ac-matrix-head--billing {
    background: #fef3c7;
    color: #92400e;
}

.ac-matrix-head--main {
    background: #e0e7ff;
    color: #3730a3;
}

.ac-tab-meta {
    display: block;
    margin-top: 0.25rem;
    font-size: var(--emr-type-metadata);
    font-weight: var(--emr-weight-label);
    color: #64748b;
    text-transform: none;
    letter-spacing: 0;
}

.ac-hierarchy {
    border: 1px solid #dbeafe;
    background: #f8fbff;
    border-radius: 0.65rem;
    padding: 0.85rem 1rem;
}

.ac-hierarchy h4 {
    margin: 0 0 0.35rem;
    font-size: var(--emr-type-card-title);
    line-height: var(--emr-leading-card-title);
    color: #1e3a8a;
}

.ac-hierarchy p {
    margin: 0 0 0.65rem;
    font-size: var(--emr-type-body);
    color: #334155;
}

.ac-hierarchy-area {
    display: grid;
    grid-template-columns: 7.5rem 1fr;
    gap: 0.5rem;
    font-size: var(--emr-type-body);
    margin-bottom: 0.35rem;
    color: #0f172a;
}

.ac-hierarchy-area strong {
    color: #1e3a5f;
}

.ac-hierarchy-note {
    margin: 0.65rem 0 0 !important;
    font-size: var(--emr-type-helper) !important;
    color: #64748b !important;
}

.ac-matrix-table {
    width: 100%;
    border-collapse: collapse;
    font-size: var(--emr-type-table);
}

.ac-matrix-table th,
.ac-matrix-table td {
    border-top: 1px solid #e2e8f0;
    padding: 0.55rem 0.8rem;
    text-align: center;
}

.ac-matrix-table thead th {
    background: #f8fafc;
    font-size: var(--emr-type-table-head);
    font-weight: var(--emr-weight-title);
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.ac-matrix-table tbody th {
    text-align: left;
    font-weight: 500;
    color: #0f172a;
}

.ac-radio {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.ac-radio input[type="radio"] {
    width: 1rem;
    height: 1rem;
    accent-color: #2563eb;
}

.ac-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-top: 1.15rem;
}

.ac-footer--user {
    justify-content: space-between;
}

.ac-save--default {
    background: #2563eb !important;
    color: #fff !important;
}

.ac-save--default:hover {
    background: #1d4ed8 !important;
}

.ac-save--user {
    background: #15803d !important;
    color: #fff !important;
}

.ac-save--user:hover {
    background: #166534 !important;
}

.ac-reset {
    color: #475569;
}

.ac-loading,
.ac-footnote {
    font-size: var(--emr-type-helper);
    color: #64748b;
}

.ac-footnote {
    margin: 0.75rem 0 0;
}

@media (max-width: 900px) {
    .ac-tabs,
    .ac-toolbar,
    .ac-toolbar--user,
    .ac-employee,
    .ac-footer,
    .ac-footer--user {
        grid-template-columns: 1fr;
        display: flex;
        flex-direction: column;
    }
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}

.file\\:text-sm::file-selector-button{
  font-size: 14px;
  line-height: 1.45;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}

.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}

.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}

.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child{
  border-left-width: 1px;
}

.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.focus-within\\:relative:focus-within{
  position: relative;
}

.focus-within\\:z-20:focus-within{
  z-index: 20;
}

.hover\\:border-\\[\\#6B4C9A\\]\\/40:hover{
  border-color: rgb(107 76 154 / 0.4);
}

.hover\\:bg-\\[\\#0a4b3f\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(10 75 63 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#132a44\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(19 42 68 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1869CC\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(24 105 204 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1e40af\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#5A3D86\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(90 61 134 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#E5F0FF\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 240 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F3EEF8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 238 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}

.hover\\:bg-amber-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}

.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-sky-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-transparent:hover{
  background-color: transparent;
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/5:hover{
  background-color: rgb(255 255 255 / 0.05);
}

.hover\\:text-\\[\\#1E79E8\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(30 121 232 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#1e3a8a\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#6B4C9A\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(107 76 154 / var(--tw-text-opacity, 1));
}

.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}

.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}

.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}

.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}

.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-700:hover{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-200:hover{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:text-teal-800:hover{
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.focus\\:border-slate-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}

.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}

.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}

.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}

.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}

.focus\\:opacity-100:focus{
  opacity: 1;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-500\\/40:focus{
  --tw-ring-color: rgb(59 130 246 / 0.4);
}

.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-teal-600\\/40:focus{
  --tw-ring-color: rgb(13 148 136 / 0.4);
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}

.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}

.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}

.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}

.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}

.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}

.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}

.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}

.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up{
  from{
    height: var(--radix-accordion-content-height);
  }
  to{
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down{
  from{
    height: 0;
  }
  to{
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}

.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}

.data-\\[state\\=checked\\]\\:bg-teal-700[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}

.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}

@media (min-width: 640px){
  .sm\\:bottom-0{
    bottom: 0px;
  }
  .sm\\:right-0{
    right: 0px;
  }
  .sm\\:top-auto{
    top: auto;
  }
  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .sm\\:mt-0{
    margin-top: 0px;
  }
  .sm\\:block{
    display: block;
  }
  .sm\\:inline{
    display: inline;
  }
  .sm\\:table-cell{
    display: table-cell;
  }
  .sm\\:w-\\[220px\\]{
    width: 220px;
  }
  .sm\\:min-w-\\[240px\\]{
    min-width: 240px;
  }
  .sm\\:max-w-2xl{
    max-width: 42rem;
  }
  .sm\\:max-w-\\[248px\\]{
    max-width: 248px;
  }
  .sm\\:max-w-lg{
    max-width: 32rem;
  }
  .sm\\:max-w-md{
    max-width: 28rem;
  }
  .sm\\:max-w-sm{
    max-width: 24rem;
  }
  .sm\\:flex-none{
    flex: none;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:flex-col{
    flex-direction: column;
  }
  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }
  .sm\\:items-start{
    align-items: flex-start;
  }
  .sm\\:items-end{
    align-items: flex-end;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:justify-between{
    justify-content: space-between;
  }
  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }
  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}

@media (min-width: 768px){
  .md\\:absolute{
    position: absolute;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .md\\:block{
    display: block;
  }
  .md\\:table-cell{
    display: table-cell;
  }
  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:text-sm{
    font-size: 14px;
    line-height: 1.45;
  }
}

@media (min-width: 1024px){
  .lg\\:block{
    display: block;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:justify-between{
    justify-content: space-between;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 1280px){
  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_280px\\]{
    grid-template-columns: minmax(0,1fr) 280px;
  }
  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_300px\\]{
    grid-template-columns: minmax(0,1fr) 300px;
  }
}

.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 13px;
  line-height: 1.35;
}

.\\[\\&\\:empty\\]\\:before\\:pointer-events-none:empty::before{
  content: var(--tw-content);
  pointer-events: none;
}

.\\[\\&\\:empty\\]\\:before\\:text-slate-400:empty::before{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.\\[\\&\\:empty\\]\\:before\\:content-\\[attr\\(data-placeholder\\)\\]:empty::before{
  --tw-content: attr(data-placeholder);
  content: var(--tw-content);
}

.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-none:has([aria-selected]){
  border-radius: 0px;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}

.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}

.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 13px;
  line-height: 1.35;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}

.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}

.\\[\\&_th\\]\\:overflow-hidden th{
  overflow: hidden;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,0FAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;QAAA,uBAAc;QAAd,uBAAc;QAAd,iBAAc;QAAd,4BAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,kBAAc;QAAd,8BAAc;QAAd,uBAAc;QAAd,+BAAc;QAAd,mBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,4BAAc;QAAd,4BAAc;QAAd,kCAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,iBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,qBAAc;QAAd,gBAAc;IAAA;AAAd;QAAA,uBAAc;QAAd,sBAAc;QAAd,iBAAc;QAAd,2BAAc;QAAd,oBAAc;QAAd,8BAAc;QAAd,mBAAc;QAAd,6BAAc;QAAd,uBAAc;QAAd,gCAAc;QAAd,mBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,6BAAc;QAAd,4BAAc;QAAd,kCAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,kBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,sBAAc;IAAA;AAAd;EAAA;AAAc;AAAd;EAAA,wCAAc;EAAd;AAAc;AAAd;QAAA,4BAAc;IAAA;AAAd;QAAA,oBAAc;QAAd,qBAAc;QAAd,mBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,sBAAc;QAAd,oBAAc;QAAd,uBAAc;QAAd,mBAAc;QAAd,gBAAc;QAAd,YAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;QAAd,0BAAc;QAAd,2BAAc;QAAd,yBAAc;QAAd,4BAAc;IAAA;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;IACI,SAAS;IACT,iCAAiC;IACjC,+BAA+B;IAC/B,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAmEA,6EAA6E;AAC7E;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;;QAEI,uBAAuB;QACvB,wBAAwB;QACxB,4BAA4B;QAC5B,2BAA2B;QAC3B,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;;;;MAIE;IACF;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,sBAAsB;QACtB,cAAc;QACd,2BAA2B;QAC3B,iCAAiC;IACrC;;IAEA;QACI,gCAAgC;QAChC,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAmB;QAAnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,qBAAqB;QACrB,qBAAqB;QACrB,iCAAiC;QACjC,eAAe;QACf,iBAAiB;QACjB,yBAAyB;QACzB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX;;;;;UAKE;QACF,8BAA8B;QAC9B,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;QACjB,wBAAwB;QACxB,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;;QAEI,cAAc;QACd,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gCAAgC;QAChC,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,yFAAyF;AACzF;IACI,qBAAqB;IACrB,oBAAoB;IACpB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;IACf,qDAAqD;AACzD;;AAEA;;;;IAII,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;;IAEI,YAAY;IACZ,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,4CAA4C;IAC5C,gBAAgB;IAChB,mDAAmD;IACnD,qDAAqD;IACrD,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,4CAA4C;IAC5C,eAAe;IACf,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,oCAAoC;IACpC,sBAAsB;IACtB,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mCAAmC;IACnC,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,gCAAgC;IAChC,oCAAoC;IACpC,0CAA0C;IAC1C,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,mDAAmD;IACnD,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA,8EAA8E;AAC9E;IACI,kBAAkB;IAClB,MAAM;IACN,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mDAAmD;AACvD;;AAEA;IACI,cAAc;AAClB;;AAEA,0FAA0F;AAC1F;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,yEAAyE;AAC7E;;AAEA;IACI,QAAQ;IACR,wEAAwE;AAC5E;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,4CAA4C;IAC5C,YAAY;IACZ,kDAAkD;AACtD;;AAEA,+EAA+E;AAC/E;IACI,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;+DAC+D;AAC/D;IACI,aAAa;IACb,gDAAgD;IAChD,wBAAwB;IACxB,WAAW;IACX,MAAM;IACN,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;AACjB;;;AAGA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,MAAM;QACN,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,mCAAmC;QACnC,sBAAsB;IAC1B;AACJ;;AAkCA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,qCAAqC;IACrC,oCAAoC;IACpC,0CAA0C;IAC1C,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;IACxC,oCAAoC;IACpC,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,oCAAoC;IACpC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gCAAgC;IAChC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,mCAAmC;IACnC,oCAAoC;IACpC,cAAc;IACd,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,WAAW;IACX,+BAA+B;IAC/B,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,4CAA4C;IAC5C,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;IAEI,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,oCAAoC;IACpC,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;;;;;;QAMI,0BAA0B;QAC1B,aAAa;QACb,sBAAsB;IAC1B;AACJ;;AA9kCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,eAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA,QAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA,sBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,iDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,sBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,8BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,2GAglCA;EAhlCA,yGAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,2GAglCA;EAhlCA,yGAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,8BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,2GAglCA;EAhlCA,yGAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,2GAglCA;EAhlCA,yGAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,+EAglCA;EAhlCA,mGAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,yBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,yBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,sBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,qBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,qBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,gDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,iDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;AAAA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;AAAA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,0EAglCA;EAhlCA,8FAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,qBAglCA;EAhlCA,yBAglCA;EAhlCA,2BAglCA;EAhlCA,yBAglCA;EAhlCA,0BAglCA;EAhlCA,+BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,qBAglCA;EAhlCA,yBAglCA;EAhlCA,2BAglCA;EAhlCA,yBAglCA;EAhlCA,0BAglCA;EAhlCA,+BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,qBAglCA;EAhlCA,yBAglCA;EAhlCA,2BAglCA;EAhlCA,yBAglCA;EAhlCA,0BAglCA;EAhlCA,+BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA,yBAglCA;EAhlCA,0BAglCA;EAhlCA,wBAglCA;EAhlCA,yBAglCA;EAhlCA,8BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA,yBAglCA;EAhlCA,0BAglCA;EAhlCA,wBAglCA;EAhlCA,yBAglCA;EAhlCA,8BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA,yBAglCA;EAhlCA,0BAglCA;EAhlCA,wBAglCA;EAhlCA,yBAglCA;EAhlCA,8BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA,yBAglCA;EAhlCA,0BAglCA;EAhlCA,wBAglCA;EAhlCA,yBAglCA;EAhlCA,8BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA,sBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA,qBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,mBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA,uBAglCA;IAhlCA,sDAglCA;IAhlCA;EAglCA;EAhlCA;IAAA,uBAglCA;IAhlCA,oDAglCA;IAhlCA;EAglCA;EAhlCA;IAAA,uBAglCA;IAhlCA,2DAglCA;IAhlCA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA,oBAglCA;IAhlCA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;AAAA;;AAhlCA;EAAA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA,eAglCA;IAhlCA;EAglCA;AAAA;;AAhlCA;EAAA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA,kBAglCA;IAhlCA;EAglCA;AAAA;;AAhlCA;EAAA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;EAhlCA;IAAA;EAglCA;AAAA;;AAhlCA;EAAA,eAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,0BAglCA;EAhlCA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oCAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,iDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,iDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,kDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kDAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,qBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,gBAglCA;EAhlCA,oBAglCA;EAhlCA,4BAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,sBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,WAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,kBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,mBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,qBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,eAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA,oBAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA,WAglCA;EAhlCA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA;;AAhlCA;EAAA;AAglCA","sourcesContent":["@import \"./styles/emr-typography.css\";\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n    margin: 0;\n    font-family: var(--emr-font-sans);\n    font-size: var(--emr-type-body);\n    line-height: var(--emr-leading-body);\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\ncode, pre, .font-fhir {\n    font-family: var(--emr-font-mono);\n}\n\n@layer base {\n    :root {\n        --background: 0 0% 100%;\n        --foreground: 0 0% 3.9%;\n        --card: 0 0% 100%;\n        --card-foreground: 0 0% 3.9%;\n        --popover: 0 0% 100%;\n        --popover-foreground: 0 0% 3.9%;\n        --primary: 0 0% 9%;\n        --primary-foreground: 0 0% 98%;\n        --secondary: 0 0% 96.1%;\n        --secondary-foreground: 0 0% 9%;\n        --muted: 0 0% 96.1%;\n        --muted-foreground: 0 0% 45.1%;\n        --accent: 0 0% 96.1%;\n        --accent-foreground: 0 0% 9%;\n        --destructive: 0 84.2% 60.2%;\n        --destructive-foreground: 0 0% 98%;\n        --border: 0 0% 89.8%;\n        --input: 0 0% 89.8%;\n        --ring: 0 0% 3.9%;\n        --chart-1: 12 76% 61%;\n        --chart-2: 173 58% 39%;\n        --chart-3: 197 37% 24%;\n        --chart-4: 43 74% 66%;\n        --chart-5: 27 87% 67%;\n        --radius: 0.5rem;\n    }\n    .dark {\n        --background: 0 0% 3.9%;\n        --foreground: 0 0% 98%;\n        --card: 0 0% 3.9%;\n        --card-foreground: 0 0% 98%;\n        --popover: 0 0% 3.9%;\n        --popover-foreground: 0 0% 98%;\n        --primary: 0 0% 98%;\n        --primary-foreground: 0 0% 9%;\n        --secondary: 0 0% 14.9%;\n        --secondary-foreground: 0 0% 98%;\n        --muted: 0 0% 14.9%;\n        --muted-foreground: 0 0% 63.9%;\n        --accent: 0 0% 14.9%;\n        --accent-foreground: 0 0% 98%;\n        --destructive: 0 62.8% 30.6%;\n        --destructive-foreground: 0 0% 98%;\n        --border: 0 0% 14.9%;\n        --input: 0 0% 14.9%;\n        --ring: 0 0% 83.1%;\n        --chart-1: 220 70% 50%;\n        --chart-2: 160 60% 45%;\n        --chart-3: 30 80% 55%;\n        --chart-4: 280 65% 60%;\n        --chart-5: 340 75% 55%;\n    }\n}\n\n@layer base {\n    * {\n        @apply border-border;\n    }\n    body {\n        @apply bg-background text-foreground;\n    }\n}\n\n/* Print Note: hide Encounter chrome; show only the selected-note document. */\n.note-print-root {\n    display: none;\n}\n\n@media print {\n    @page {\n        size: letter;\n        margin: 0.6in;\n    }\n\n    html,\n    body {\n        height: auto !important;\n        min-height: 0 !important;\n        overflow: visible !important;\n        background: #fff !important;\n        margin: 0 !important;\n        padding: 0 !important;\n    }\n\n    /*\n     * beforeprint hoists .note-print-root onto document.body. Hide every other\n     * body child so Encounter chrome (visibility:hidden still occupies space)\n     * cannot generate a blank first sheet.\n     */\n    body > *:not(.note-print-root) {\n        display: none !important;\n    }\n\n    .note-print-root {\n        display: block !important;\n        position: static !important;\n        width: 100% !important;\n        color: #0f172a;\n        background: #fff !important;\n        font-family: var(--emr-font-sans);\n    }\n\n    .note-print-header {\n        border-bottom: 2px solid #0f172a;\n        padding-bottom: 12px;\n        margin-bottom: 18px;\n    }\n\n    .note-print-kicker {\n        margin: 0 0 4px;\n        font-size: 11px;\n        font-weight: 600;\n        letter-spacing: 0.16em;\n        text-transform: uppercase;\n        color: #475569;\n    }\n\n    .note-print-header h1 {\n        margin: 0;\n        font-size: 22px;\n        font-weight: 700;\n        line-height: 1.2;\n    }\n\n    .note-print-title {\n        margin: 6px 0 0;\n        font-size: 13px;\n        color: #334155;\n    }\n\n    .note-print-section {\n        margin-bottom: 16px;\n        break-inside: avoid;\n    }\n\n    .note-print-section h2 {\n        margin: 0 0 8px;\n        font-size: 11px;\n        font-weight: 700;\n        letter-spacing: 0.12em;\n        text-transform: uppercase;\n        color: #64748b;\n    }\n\n    .note-print-section dl {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 6px 24px;\n        margin: 0;\n    }\n\n    .note-print-fact dt {\n        font-size: 10px;\n        font-weight: 600;\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n        color: #64748b;\n    }\n\n    .note-print-fact dd {\n        margin: 1px 0 0;\n        font-size: 13px;\n        font-weight: 500;\n    }\n\n    .note-print-body {\n        margin: 0;\n        white-space: pre-wrap;\n        word-wrap: break-word;\n        font-family: var(--emr-font-sans);\n        font-size: 13px;\n        line-height: 1.55;\n        border: 1px solid #cbd5e1;\n        padding: 14px;\n        min-height: 8rem;\n    }\n\n    .note-print-body--rtf {\n        white-space: normal;\n    }\n\n    .note-print-body--rtf p,\n    .note-print-body--rtf div {\n        margin: 0 0 0.35em;\n    }\n\n    .note-print-body--rtf ul,\n    .note-print-body--rtf ol {\n        margin: 0 0 0.35em 1.2em;\n        padding: 0;\n    }\n\n    .note-print-root--templated .note-print-page {\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        /*\n         * Fill the letter content box (11in minus 0.6in @page margins) so flex\n         * can park .note-print-template-footer at the bottom of unused space.\n         * Keep height:auto + page-break-inside:auto — a fixed 9.8in box with\n         * page-break-inside:avoid is deferred to sheet 2 and clips long notes.\n         */\n        min-height: calc(11in - 1.2in);\n        height: auto;\n        max-height: none;\n        overflow: visible;\n        break-after: page;\n        page-break-after: always;\n        break-inside: auto;\n        page-break-inside: auto;\n    }\n\n    .note-print-root--templated .note-print-page:last-child {\n        break-after: auto;\n        page-break-after: auto;\n    }\n\n    .note-print-template-header,\n    .note-print-template-footer {\n        flex: 0 0 auto;\n        color: #0f172a;\n        font-size: 12px;\n        line-height: 1.4;\n    }\n\n    .note-print-template-header {\n        border-bottom: 1px solid #94a3b8;\n        padding-bottom: 10px;\n        margin-bottom: 12px;\n    }\n\n    .note-print-template-header--subsequent {\n        font-size: 11px;\n        padding-bottom: 6px;\n        margin-bottom: 10px;\n    }\n\n    .note-print-page__body {\n        flex: 1 1 auto;\n        min-height: 0;\n        overflow: visible;\n    }\n\n    .note-print-template-footer {\n        border-top: 1px solid #94a3b8;\n        padding-top: 8px;\n        margin-top: auto;\n        font-size: 11px;\n        color: #334155;\n    }\n\n    .note-print-root img.grd-logo {\n        max-height: 48px;\n        max-width: 160px;\n        display: inline-block;\n    }\n\n    .note-print-root--templated .note-print-body {\n        border: 0;\n        padding: 0;\n        min-height: 0;\n    }\n\n    [data-sonner-toaster] {\n        display: none !important;\n    }\n}\n\n.sidebar-nav-sheet > button {\n    color: rgb(148 163 184);\n}\n\n/* Traditional paper medical-chart folder: rounded tabs, flared joins, layered shadows. */\n.chart-folder {\n    --chart-rail: #fffdf8;\n    --chart-ink: #2c2118;\n    --chart-folder-edge: rgba(60, 40, 20, 0.22);\n}\n\n.chart-folder-nav {\n    position: relative;\n    z-index: 4;\n    background: var(--chart-rail);\n    padding: 8px 10px 0;\n    box-shadow: none;\n}\n\n.chart-dividers {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    align-items: end;\n    gap: 10px;\n    padding: 0 6px;\n}\n\n.chart-divider,\n.chart-subtab {\n    --tab-bg: #d4c4a0;\n    position: relative;\n    border: 0;\n    background: var(--tab-bg);\n    color: var(--chart-ink, #2c2118);\n    cursor: pointer;\n    filter: drop-shadow(0 3px 3px rgba(50, 32, 12, 0.22));\n}\n\n.chart-divider::before,\n.chart-divider::after,\n.chart-subtab::before,\n.chart-subtab::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    width: 12px;\n    height: 12px;\n    pointer-events: none;\n    background: transparent;\n}\n\n.chart-divider::before,\n.chart-subtab::before {\n    left: -11px;\n    border-bottom-right-radius: 12px;\n    box-shadow: 6px 0 0 var(--tab-bg);\n}\n\n.chart-divider::after,\n.chart-subtab::after {\n    right: -11px;\n    border-bottom-left-radius: 12px;\n    box-shadow: -6px 0 0 var(--tab-bg);\n}\n\n.chart-divider::before,\n.chart-divider::after {\n    display: none;\n}\n\n.chart-divider {\n    z-index: 1;\n    display: flex;\n    min-height: 64px;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    margin: 0 8px;\n    padding: 12px 16px 14px;\n    border-radius: 18px 14px 0 0 / 16px 13px 0 0;\n    text-align: left;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.48);\n    filter: drop-shadow(0 2px 2px rgba(50, 32, 12, 0.16));\n    transform: none;\n    clip-path: none;\n}\n\n.chart-divider.is-active {\n    z-index: 5;\n    min-height: 64px;\n    padding-bottom: 14px;\n    border-radius: 18px 14px 0 0 / 16px 13px 0 0;\n    transform: none;\n    filter: none;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.chart-divider:hover:not(.is-active) {\n    filter: brightness(1.05);\n}\n\n.chart-divider:focus-visible {\n    outline: 2px solid rgba(44, 33, 24, 0.28);\n    outline-offset: 2px;\n}\n\n.chart-divider-icon {\n    width: 22px;\n    height: 22px;\n    flex-shrink: 0;\n}\n\n.chart-divider-copy {\n    min-width: 0;\n}\n\n.chart-divider-label {\n    display: block;\n    font-size: var(--emr-type-body);\n    font-weight: var(--emr-weight-title);\n    letter-spacing: 0.08em;\n    line-height: var(--emr-leading-page-title);\n    text-transform: uppercase;\n}\n\n.chart-divider-sub {\n    display: none;\n    margin-top: 3px;\n    font-size: var(--emr-type-metadata);\n    font-weight: var(--emr-weight-body);\n    letter-spacing: 0;\n    line-height: 1.3;\n    text-transform: none;\n    color: #5c4a3a;\n}\n\n.chart-divider-sub.is-active {\n    color: #4a3a2c;\n}\n\n.chart-subtabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 14px;\n    align-items: flex-end;\n    padding: 10px 16px 14px;\n    margin-bottom: -14px;\n    background: transparent;\n    position: relative;\n    z-index: 3;\n}\n\n.chart-subtab {\n    z-index: 2;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    min-height: 34px;\n    margin: 0 6px;\n    padding: 7px 13px 16px;\n    border-radius: 10px 10px 0 0;\n    font-size: var(--emr-type-label);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-page-title);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n.chart-subtab-icon {\n    width: 13px;\n    height: 13px;\n    flex-shrink: 0;\n}\n\n.chart-subtab.is-active {\n    z-index: 6;\n    color: #2c2118;\n    padding-bottom: 18px;\n    box-shadow: inset 0 3px 0 var(--tab-color, #8fa87a);\n    filter: drop-shadow(0 4px 5px rgba(50, 32, 12, 0.18));\n}\n\n.chart-folder-body {\n    position: relative;\n    z-index: 1;\n    background: #fffdf8;\n    border: 1px solid rgba(60, 40, 20, 0.14);\n    border-top: 0;\n    border-radius: 0 0 8px 8px;\n    box-shadow: 0 4px 12px rgba(50, 32, 12, 0.12);\n}\n\n.chart-folder-body::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    height: 14px;\n    background: var(--chart-rail);\n    pointer-events: none;\n}\n\n.chart-subtab.is-dark:not(.is-active) {\n    color: #fffdf8;\n}\n\n/* Clinical hanging-file paper tabs only — does not affect main folder tabs. */\n.chart-subtabs--clinical {\n    position: relative;\n    gap: 0;\n    align-items: flex-end;\n    padding: 8px 0 0;\n    margin-bottom: 0;\n    z-index: 5;\n}\n\n.chart-subtabs--clinical .chart-subtab {\n    z-index: 2;\n    margin: 0 0 0 -16px;\n    padding: 9px 18px 22px;\n    min-height: 36px;\n    border-radius: 14px 11px 0 0 / 12px 13px 0 0;\n    transform: none;\n    clip-path: none;\n    filter: none;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.28);\n}\n\n.chart-subtabs--clinical .chart-subtab:first-child {\n    margin-left: 0;\n}\n\n/* Outer row edges blend into the sage folder margin. Inner tab shape/overlap unchanged. */\n.chart-subtabs--clinical::before,\n.chart-subtabs--clinical::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: -6px;\n    width: 20px;\n    pointer-events: none;\n    z-index: 16;\n}\n\n.chart-subtabs--clinical::before {\n    left: 0;\n    background: linear-gradient(to right, var(--chart-rail) 40%, transparent);\n}\n\n.chart-subtabs--clinical::after {\n    right: 0;\n    background: linear-gradient(to left, var(--chart-rail) 40%, transparent);\n}\n\n.chart-subtabs--clinical .chart-subtab:first-child::before {\n    display: none;\n}\n\n.chart-subtabs--clinical .chart-subtab:last-child::after {\n    display: none;\n}\n\n.chart-subtabs--clinical .chart-subtab::before,\n.chart-subtabs--clinical .chart-subtab::after {\n    display: block;\n    width: 10px;\n    height: 10px;\n    background: transparent;\n}\n\n.chart-subtabs--clinical .chart-subtab::before {\n    left: -9px;\n    border-bottom-right-radius: 11px;\n    box-shadow: 5px 0 0 var(--tab-bg);\n}\n\n.chart-subtabs--clinical .chart-subtab::after {\n    right: -8px;\n    width: 11px;\n    height: 9px;\n    border-bottom-left-radius: 10px;\n    box-shadow: -5px 0 0 var(--tab-bg);\n}\n\n.chart-subtabs--clinical .chart-subtab.is-active {\n    z-index: 12;\n    transform: none;\n    padding-bottom: 22px;\n    border-radius: 12px 14px 0 0 / 13px 12px 0 0;\n    filter: none;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n/* Domain (main) tabs reuse clinical subtab behavior; only size/shape differ. */\n.chart-subtabs--domain.chart-subtabs--clinical .chart-subtab {\n    min-height: 48px;\n    padding: 10px 20px 22px;\n    gap: 12px;\n    border-radius: 18px 14px 0 0 / 16px 13px 0 0;\n}\n\n.chart-subtabs--domain .chart-subtab-icon {\n    width: 22px;\n    height: 22px;\n}\n\n.chart-subtabs--domain .chart-divider-label {\n    text-transform: uppercase;\n}\n\n/* Domain main tabs only: share the available chart width equally.\n   Does not affect clinical, front-desk, or billing sub-tabs. */\n.chart-subtabs--domain.chart-subtabs--clinical {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    justify-content: stretch;\n    width: 100%;\n    gap: 0;\n    padding-left: 12px;\n    padding-right: 12px;\n}\n\n.chart-subtabs--domain.chart-subtabs--clinical .chart-subtab {\n    margin-left: 0;\n    margin-right: 0;\n    width: 100%;\n    min-width: 0;\n    justify-content: center;\n}\n\n.chart-subtabs--domain.chart-subtabs--clinical::before,\n.chart-subtabs--domain.chart-subtabs--clinical::after {\n    display: none;\n}\n\n\n.chart-folder:has(.chart-subtabs--clinical) .chart-folder-body::before {\n    height: 0;\n}\n\n.chart-folder:has(.chart-subtabs--clinical) .chart-folder-sheet {\n    padding-top: 20px;\n}\n\n.chart-folder-sheet {\n    padding-top: 1.55rem;\n}\n\n.chart-panel {\n    border-radius: 6px;\n    border: 1px solid #e4d8c8;\n    background: #ffffff;\n    box-shadow: 0 1px 1px rgba(50, 32, 12, 0.05);\n}\n\n.chart-patient-header {\n    background: #fbf6ee;\n    border-bottom: 1px solid #e4d8c8;\n}\n\n.chart-ai-panel {\n    background: #f7f4fb;\n    border-left: 1px solid #d4c8e8;\n}\n\n.chart-ai-head {\n    background: #c4b4d8;\n    color: #2c2140;\n    border-bottom: 1px solid #b8a4d0;\n}\n\n.chart-ai-head h2 {\n    color: #3d2a66;\n}\n\n@media (min-width: 640px) {\n    .chart-divider-sub {\n        display: block;\n    }\n}\n\n@media (max-width: 720px) {\n    .chart-dividers {\n        gap: 4px;\n        padding-left: 12px;\n        padding-right: 12px;\n    }\n\n    .chart-subtabs--domain.chart-subtabs--clinical {\n        gap: 0;\n        padding-left: 8px;\n        padding-right: 8px;\n    }\n\n    .chart-divider {\n        min-height: 58px;\n        padding: 10px 8px 12px;\n        gap: 8px;\n    }\n\n    .chart-divider-label {\n        font-size: var(--emr-type-metadata);\n        letter-spacing: 0.05em;\n    }\n}\n\n@layer base {\n    [data-debug-wrapper=\"true\"] {\n        display: contents !important;\n    }\n\n    [data-debug-wrapper=\"true\"] > * {\n        margin-left: inherit;\n        margin-right: inherit;\n        margin-top: inherit;\n        margin-bottom: inherit;\n        padding-left: inherit;\n        padding-right: inherit;\n        padding-top: inherit;\n        padding-bottom: inherit;\n        column-gap: inherit;\n        row-gap: inherit;\n        gap: inherit;\n        border-left-width: inherit;\n        border-right-width: inherit;\n        border-top-width: inherit;\n        border-bottom-width: inherit;\n        border-left-style: inherit;\n        border-right-style: inherit;\n        border-top-style: inherit;\n        border-bottom-style: inherit;\n        border-left-color: inherit;\n        border-right-color: inherit;\n        border-top-color: inherit;\n        border-bottom-color: inherit;\n    }\n}\n\n.ac-page {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n}\n\n.ac-hero {\n    background: #1e3a5f;\n    color: #fff;\n    border-radius: 0.75rem;\n    padding: 1.1rem 1.35rem;\n}\n\n.ac-hero h1 {\n    margin: 0;\n    font-size: var(--emr-type-page-title);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-page-title);\n    letter-spacing: -0.02em;\n}\n\n.ac-hero p {\n    margin: 0.3rem 0 0;\n    font-size: var(--emr-type-body);\n    color: #d6e4f5;\n}\n\n.ac-tabs {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 0.75rem;\n}\n\n.ac-tab {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    border: 1px solid #dbe3ee;\n    background: #fff;\n    border-radius: 0.75rem;\n    padding: 0.85rem 1rem;\n    text-align: left;\n    color: #334155;\n}\n\n.ac-tab.is-active {\n    border-color: #2563eb;\n    box-shadow: 0 0 0 1px #2563eb;\n    color: #1e3a5f;\n}\n\n.ac-tab.is-disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.ac-tab-label {\n    display: block;\n    font-size: var(--emr-type-card-title);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-card-title);\n}\n\n.ac-tab-sub {\n    display: block;\n    font-size: var(--emr-type-metadata);\n    color: #64748b;\n}\n\n.ac-panel {\n    border: 1px solid #e2e8f0;\n    background: #fff;\n    border-radius: 0.75rem;\n    padding: 1.25rem;\n}\n\n.ac-panel-title {\n    margin: 0 0 1rem;\n    font-size: var(--emr-type-section-title);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-heading);\n    color: #0f172a;\n}\n\n.ac-section-title {\n    margin: 1.25rem 0 0.75rem;\n    font-size: var(--emr-type-card-title);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-card-title);\n    color: #1e3a5f;\n}\n\n.ac-section-title:first-of-type {\n    margin-top: 0.25rem;\n}\n\n.ac-toolbar {\n    display: grid;\n    grid-template-columns: minmax(12rem, 16rem) 1fr;\n    gap: 1rem;\n    margin-bottom: 1rem;\n    align-items: start;\n}\n\n.ac-toolbar--user {\n    grid-template-columns: minmax(16rem, 20rem) 1fr;\n}\n\n.ac-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    font-size: var(--emr-type-label);\n    font-weight: var(--emr-weight-label);\n    color: #334155;\n}\n\n.ac-field select {\n    height: 2.4rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 0.5rem;\n    background: #fff;\n    padding: 0 0.7rem;\n    font-size: var(--emr-type-body);\n    color: #0f172a;\n}\n\n.ac-info {\n    display: flex;\n    gap: 0.6rem;\n    align-items: flex-start;\n    background: #e8f1fb;\n    border: 1px solid #c5daf3;\n    color: #1e3a5f;\n    border-radius: 0.6rem;\n    padding: 0.7rem 0.85rem;\n    font-size: var(--emr-type-body);\n}\n\n.ac-info-icon {\n    width: 1rem;\n    height: 1rem;\n    margin-top: 0.1rem;\n    flex-shrink: 0;\n}\n\n.ac-info p {\n    margin: 0;\n}\n\n.ac-employee {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 0.75rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.65rem;\n    padding: 0.75rem 0.9rem;\n    background: #f8fafc;\n}\n\n.ac-employee span {\n    display: block;\n    font-size: var(--emr-type-metadata);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #64748b;\n    font-weight: var(--emr-weight-title);\n}\n\n.ac-employee strong {\n    display: block;\n    margin-top: 0.15rem;\n    font-size: var(--emr-type-body);\n    color: #0f172a;\n    font-weight: var(--emr-weight-title);\n}\n\n.ac-status-active {\n    color: #047857 !important;\n}\n\n.ac-status-inactive {\n    color: #64748b !important;\n}\n\n.ac-matrix-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.ac-matrix {\n    border: 1px solid #e2e8f0;\n    border-radius: 0.65rem;\n    overflow: hidden;\n}\n\n.ac-matrix-head {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.65rem 0.9rem;\n    font-weight: 600;\n}\n\n.ac-matrix-head h3 {\n    margin: 0;\n    font-size: var(--emr-type-card-title);\n    line-height: var(--emr-leading-card-title);\n}\n\n.ac-matrix-head--front-desk {\n    background: #dbeafe;\n    color: #1e3a8a;\n}\n\n.ac-matrix-head--clinical {\n    background: #dcfce7;\n    color: #166534;\n}\n\n.ac-matrix-head--billing {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n.ac-matrix-head--main {\n    background: #e0e7ff;\n    color: #3730a3;\n}\n\n.ac-tab-meta {\n    display: block;\n    margin-top: 0.25rem;\n    font-size: var(--emr-type-metadata);\n    font-weight: var(--emr-weight-label);\n    color: #64748b;\n    text-transform: none;\n    letter-spacing: 0;\n}\n\n.ac-hierarchy {\n    border: 1px solid #dbeafe;\n    background: #f8fbff;\n    border-radius: 0.65rem;\n    padding: 0.85rem 1rem;\n}\n\n.ac-hierarchy h4 {\n    margin: 0 0 0.35rem;\n    font-size: var(--emr-type-card-title);\n    line-height: var(--emr-leading-card-title);\n    color: #1e3a8a;\n}\n\n.ac-hierarchy p {\n    margin: 0 0 0.65rem;\n    font-size: var(--emr-type-body);\n    color: #334155;\n}\n\n.ac-hierarchy-area {\n    display: grid;\n    grid-template-columns: 7.5rem 1fr;\n    gap: 0.5rem;\n    font-size: var(--emr-type-body);\n    margin-bottom: 0.35rem;\n    color: #0f172a;\n}\n\n.ac-hierarchy-area strong {\n    color: #1e3a5f;\n}\n\n.ac-hierarchy-note {\n    margin: 0.65rem 0 0 !important;\n    font-size: var(--emr-type-helper) !important;\n    color: #64748b !important;\n}\n\n.ac-matrix-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: var(--emr-type-table);\n}\n\n.ac-matrix-table th,\n.ac-matrix-table td {\n    border-top: 1px solid #e2e8f0;\n    padding: 0.55rem 0.8rem;\n    text-align: center;\n}\n\n.ac-matrix-table thead th {\n    background: #f8fafc;\n    font-size: var(--emr-type-table-head);\n    font-weight: var(--emr-weight-title);\n    color: #475569;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.ac-matrix-table tbody th {\n    text-align: left;\n    font-weight: 500;\n    color: #0f172a;\n}\n\n.ac-radio {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.ac-radio input[type=\"radio\"] {\n    width: 1rem;\n    height: 1rem;\n    accent-color: #2563eb;\n}\n\n.ac-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    margin-top: 1.15rem;\n}\n\n.ac-footer--user {\n    justify-content: space-between;\n}\n\n.ac-save--default {\n    background: #2563eb !important;\n    color: #fff !important;\n}\n\n.ac-save--default:hover {\n    background: #1d4ed8 !important;\n}\n\n.ac-save--user {\n    background: #15803d !important;\n    color: #fff !important;\n}\n\n.ac-save--user:hover {\n    background: #166534 !important;\n}\n\n.ac-reset {\n    color: #475569;\n}\n\n.ac-loading,\n.ac-footnote {\n    font-size: var(--emr-type-helper);\n    color: #64748b;\n}\n\n.ac-footnote {\n    margin: 0.75rem 0 0;\n}\n\n@media (max-width: 900px) {\n    .ac-tabs,\n    .ac-toolbar,\n    .ac-toolbar--user,\n    .ac-employee,\n    .ac-footer,\n    .ac-footer--user {\n        grid-template-columns: 1fr;\n        display: flex;\n        flex-direction: column;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
